import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CwTxSummary } from '../models/cw-tx-summary.model'
import { initialPanelState } from '../utils/clearwater-transactions-panel-state-utils'

export const clearwaterTransactionsFeatureKey = 'clearwaterTransactions'

export const clearwaterTransactionsSlice = createSlice({
  name: clearwaterTransactionsFeatureKey,
  initialState: initialPanelState,
  reducers: {
    clearAllFilters: oldState => ({
      ...oldState,
      filters: initialPanelState.filters,
    }),
    setClearedTimestampFilter: (
      oldState,
      action: PayloadAction<{ showCleared: boolean; showUncleared: boolean }>,
    ) => ({
      ...oldState,
      filters: {
        ...oldState.filters,
        clearedTimestampToggle: action.payload.showCleared,
        unclearedTimestampToggle: action.payload.showUncleared,
      },
    }),
    setClearedTimestampToggle: (oldState, action: PayloadAction<boolean>) => ({
      ...oldState,
      filters: {
        ...oldState.filters,
        clearedTimestampToggle: action.payload,
      },
    }),
    setUnclearedTimestampToggle: (
      oldState,
      action: PayloadAction<boolean>,
    ) => ({
      ...oldState,
      filters: {
        ...oldState.filters,
        unclearedTimestampToggle: action.payload,
      },
    }),
    setSelectAllState: (oldState, action: PayloadAction<boolean>) => ({
      ...oldState,
      isSelectAllRowsEnabled: action.payload,
    }),
    setSelectAllSummaryData: (
      oldState,
      action: PayloadAction<CwTxSummary>,
    ) => ({
      ...oldState,
      selectedRowsSummaryData: action.payload,
    }),
  },
})

export const {
  clearAllFilters,
  setClearedTimestampFilter,
  setClearedTimestampToggle,
  setUnclearedTimestampToggle,
  setSelectAllState,
  setSelectAllSummaryData,
} = clearwaterTransactionsSlice.actions

export default clearwaterTransactionsSlice.reducer
